import { graphql } from 'react-relay';

const CreateAttachmentMutation = graphql`
    mutation CreateAttachmentMutation($input: AttachmentTypeInput!, $connections: [ID!]!) {
        createAttachment(input: $input) @appendEdge(connections: $connections) {
            cursor
            node {
                ...AttachmentFragment
            }
        }
    }
`;

export default CreateAttachmentMutation;
